import { BUPlatformList } from './Components/BUPlatformList';

export const BUManager = () => {
  return <BUPlatformList />;
};
